import { gql } from '@apollo/client'

const GET_LIST_CAMPAIGNS = gql`
  query ($limit: Int, $nextPage: String) {
    listCampaigns(limit: $limit, nextPage: $nextPage) {
      items {
        campaignId
        name
        startDate
        endDate
        status
        responsible
      }
      nextPage
    }
  }
`

export default GET_LIST_CAMPAIGNS
